import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { UserService } from "@/services/admin/UserService"

export const getOnlineAccountUsers = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const usersQuery = UserService.getUsersForAccount(coreIdQuery.data)

  queries.add(coreIdQuery)
  queries.add(usersQuery)

  return queries.setData(usersQuery.data).getAggregate()
}
